export default __webpack_public_path__ + "static/parcels-e8f937237d237c5f50eb0ad2e51078a2.jpg";